export const QA_NAME_SEARCH_RESULTS_REQUESTS_TABLE =
  'searchResultsRequestsTable'

export const SEARCH_RESULTS_REQUESTS_CONFIG_API =
  'idwell-api/api/v3/table/tables/requests-search/'

export const SEARCH_RESULTS_REQUESTS_LIST_API =
  'idwell-api/api/v3/request/requests/filter/'

export const SEARCH_RESULTS_REQUESTS_COUNT_API =
  'idwell-api/api/v3/request/requests/filter/count/'

export const SEARCH_RESULTS_FILTER_BAR_ITEMS_PROPS = {
  SaveTemplateButton: null,
}
